import { render, staticRenderFns } from "./MapPOIMarkers.component.vue?vue&type=template&id=516cf53a&scoped=true"
import script from "./MapPOIMarkers.component.vue?vue&type=script&lang=ts"
export * from "./MapPOIMarkers.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516cf53a",
  null
  
)

export default component.exports